<script setup>
import { watch, watchEffect, ref, inject } from 'vue'
  import { RouterView, useRoute } from 'vue-router'
  import CollectionNav from '@/components/Navigation/CollectionNav.vue'
  import Navbar from '@/components/Navigation/Navbar.vue'
  import Footer from '@/components/Content/Footer.vue'

  const route = useRoute()

  const $storeNavigation = inject('$storeNavigation')

  /*
  |--------------------------------------------------------------------------
  | Navigation Status
  |--------------------------------------------------------------------------
  */
  const showingNavIDs = ref([])
  watch(() => $storeNavigation.showingNavIDs, newData => showingNavIDs.value = newData, { deep: true })
  const openNav = navID => $storeNavigation.openNav(navID)
  const getNavStatus = id => (showingNavIDs.value.length ? showingNavIDs.value.includes(id) : false)
</script>

<template>
  <Navbar />
  <div class="wrapper">
    <div class="cg-container row g-3 h-sm-100 m-auto">

        <div class="devices-nav-buttons">
          <button @click="openNav('collections')" type="button" class="btn btn-primary cg-row-content gap-2 justify-content-center collections-nav-btn" :class="{ active: getNavStatus('collections') }">
              Collections <span class="body-text-icon"><FontAwesomeIcon icon="fas fa-chevron-circle-down" /></span>
          </button>
        </div>

      <div class="col-lg-3 col-sm-6 col-12 pt-3 cg-column-content justify-content-center gap-3" :class="{ 'd-none': ! getNavStatus('collections'), 'd-sm-block': ! getNavStatus('collections') }">
        <CollectionNav />
      </div>

      <div class="devices-nav-buttons">
        <button v-if="$route.name != 'home'" @click="openNav('ginnels')" type="button" class="btn btn-primary-ginnel cg-row-content gap-2 justify-content-center ginnels-nav-btn" :class="{ active: getNavStatus('ginnels') }">
            Ginnels <span class="body-text-icon"><FontAwesomeIcon icon="fas fa-chevron-circle-down" /></span>
        </button>
      </div>

      <template v-if="$route.name == 'collection.ginnel' || $route.name == 'collection'">
        <RouterView />
      </template>

      <div v-else class="col-lg-9 col-12 pt-3 main-content">
        <RouterView />
      </div>
    </div>
  </div>
  <Footer />
</template>
